export default {
    approvals: {
        title: "Aprobata",
        error: "Wystąpił błąd"
    },
    delegates: {
        title: "Delegaci",
        error: "Wystąpił błąd",
        noDelegates: "Brak pozycji",
        delegateDelete: "Delegat został usunięty",
        confirm: {
            delete: "Usunąć delegata?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Data rozpoczęcia",
            endDate: "Data zakończenia",
        },
        buttons: {
            add: {
                text: "Dodaj delegata"
            }
        }
    },
    employees: {
        title: "Moi pracownicy",
        error: "Wystąpił błąd",
        empty: "Nie znaleziono pracowników",
        users: {
            name: "Nazwa",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Szukaj",
            }
        },
        cta: {
            orders: "Załaduj zamówienia",
            download: "Pobierz zamówienia",
            search: "Szukaj"
        }
    }
}